<select #comboBox
  [(ngModel)]="selectedMediumType" [disabled]="disabled" [hidden]="!visible"
  (change)="updateBindedField($event);onChange($any($event.target).value);" (blur)="onTouched()"
  [class.combo-box-required]="required"
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [tabindex]="tabindex">
  <ng-template ngFor let-item [ngForOf]="model.mediumList">
    <option value="{{item.MediumType}}">{{item.MediumTypeName}}</option>
  </ng-template>
</select>
